import { render, staticRenderFns } from "./BEIFOpenWindow.vue?vue&type=template&id=5c86010a&scoped=true&"
import script from "./BEIFOpenWindow.vue?vue&type=script&lang=ts&"
export * from "./BEIFOpenWindow.vue?vue&type=script&lang=ts&"
import style0 from "./BEIFOpenWindow.vue?vue&type=style&index=0&id=5c86010a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86010a",
  null
  
)

export default component.exports